<template>

    <router-link :to="{name: 'cursocisco'}">
  <v-card
    class="mx-auto mt-4 mb-4"
    max-width="344"
  >

    
  </v-card>
     </router-link>
</template>
<script>
export default {
    data: () =>({
    }),
}
</script>

<style>
.titulo{
    color: #616161;
}
</style>